import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Kbd,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { SearchTabs } from './tabs';
import { debounce } from 'lodash-es';
import { useState } from 'react';
import { Search } from '@/assets/icons/nav';
import useRolePermissions from '@/hooks/use-role-permissions';
import { KText } from '@/ui-library/components/text';
import { useKFlags } from '@/hooks/use-k-flags';

export const UniversalSearch = ({ isOpen, onClose }) => {
  const searchInput = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchLength, setSearchLength] = useState(0);
  const [selected, setSelected] = useState(0);
  const { showOutreach } = useRolePermissions();
  const { ats_enabled } = useKFlags();

  const handleChange = debounce(() => {
    setSearchLength(searchInput?.current?.value?.length);
    if (searchInput?.current && searchInput?.current?.value?.length > 2) {
      setSearchTerm(searchInput?.current?.value);
    }
  }, 300);

  //Handle arrow navigation
  function handleChangeSelected(direction) {
    const items = document.querySelectorAll('.universal--search--item');

    let index = 0;
    let newIndex = 0;
    let newItem;

    if (direction === 'down') {
      items.forEach((_, i) => {
        if (i === selected) {
          index = i;
        }
      });

      newIndex = index === items.length - 1 ? 0 : index + 1;
    } else if (direction === 'up') {
      items.forEach((_, i) => {
        if (i === selected) {
          index = i;
        }
      });

      newIndex = !index ? items.length - 1 : index - 1;
    } else {
      setSelected(0);
    }

    newItem = items[newIndex];

    if (newItem && typeof newIndex === 'number') {
      items[selected]?.classList?.remove('active');
      setSelected(newIndex);
      newItem?.classList?.add('active');
      newItem?.scrollIntoView({
        behavior: 'smooth',
        block: newIndex ? 'center' : 'end',
      });
    }
  }

  function handleSelect() {
    const items = document.querySelectorAll('.universal--search--item');

    let index = 0;
    let item;

    items?.forEach((_, i) => {
      if (i === selected) {
        index = i;
      }
    });

    item = items[index];

    if (item) {
      item.click();
    }
  }

  let showAllText;
  switch (true) {
    case showOutreach && ats_enabled:
      showAllText = 'Job, Flow or a Contact.';
      break;
    case showOutreach:
      showAllText = 'Flow or a Contact.';
      break;
    case ats_enabled:
      showAllText = 'Job or a Contact.';
      break;
    default:
      showAllText = 'Contact.';
  }
  const placeHolderText = `Find a ${showAllText} Type 3 chars to begin search.`;

  return (
    <Modal size="3xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <ModalBody p="0">
          <InputGroup
            height="60px"
            alignItems="center"
            onKeyDown={(e) => {
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                handleChangeSelected('down');
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                handleChangeSelected('up');
              } else if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                handleSelect();
              }
            }}
          >
            <InputLeftElement
              height="100%"
              pointerEvents="none"
              pl="6px"
              children={
                <Search
                  width="24px"
                  height="24px"
                  opacity={searchLength > 0 ? 1 : 0.5}
                  color="secondary-900"
                />
              }
            />
            <Input
              borderRadius="12px"
              height="100%"
              placeholder={placeHolderText}
              ref={searchInput}
              onChange={handleChange}
              border="none"
              _focus={{ border: 'none' }}
              _hover={{ border: 'none' }}
              fontSize="16px"
              pr={`${searchLength > 0 ? '1rem' : '13.5rem'}`}
            />
            <InputRightElement
              width={`${searchLength > 0 ? '1rem' : '13.5rem'}`}
              height="100%"
              children={
                searchLength <= 0 &&
                navigator.platform.indexOf('Mac') !== -1 && (
                  <KText lineHeight="26px">
                    <Kbd>⌘</Kbd> <Kbd>K</Kbd> to search anywhere
                  </KText>
                )
              }
            />
          </InputGroup>
          {searchLength > 2 && (
            <Box h="400px" borderTop="1px solid #F5F5F5" position="relative">
              <Box py="16px">
                <SearchTabs
                  searchTerm={searchTerm}
                  setSelected={setSelected}
                  handleSelect={handleSelect}
                  handleChangeSelected={handleChangeSelected}
                />
              </Box>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
